import React, { useEffect } from "react";
import WOW from "wowjs";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";


const Pricing = () => {
  const pricingItems = [
    {
      img: "img/price-1.jpg",
      title: "Blanqueamiento Dental",
      features: [
        "Equipamiento Moderno",
        "Odontóloga Profesional",
        "Atención Personalizada",
      ],
    },
    {
      img: "img/price-2.jpg",
      title: "Implantes Dentales",
      features: [
        "Equipamiento Moderno",
        "Odontóloga Profesional",
        "Atención Personalizada",
      ],
    },
    {
      img: "img/price-3.jpg",
      title: "Tratamiento de Conducto",
      features: [
        "Equipamiento Moderno",
        "Odontóloga Profesional",
        "Atención Personalizada",
      ],
    },
  ];

  useEffect(() => {
    const wow = new WOW.WOW({
      live: false,
    });
    wow.init();
  }, []);

  return (
    <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
      <div className="container">
        <div className="row g-5">
          <div className="col-lg-5">
            <div className="section-title mb-4">
              <h5 className="position-relative d-inline-block text-primary text-uppercase">
                Servicios
              </h5>
              <h1 className="display-5 mb-0">Nuestros Servicios</h1>
            </div>
            <h5
              className="text-uppercase text-primary wow fadeInUp"
              data-wow-delay="0.3s"
            >
              Contáctanos al Whatsapp
            </h5>
            <h1 className="wow fadeInUp" data-wow-delay="0.6s">
              +54 381 561-5279
            </h1>
          </div>

          {/* Swiper Carousel */}
          <div className="col-lg-7">
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              navigation
              pagination={{ clickable: true }}
              autoplay={{ delay: 3000 }}
              loop={true}
              spaceBetween={30}
              slidesPerView={1}
              className="price-carousel wow zoomIn"
              data-wow-delay="0.9s"
            >
              {pricingItems.map((item, index) => (
                <SwiperSlide key={index}>
                  <div className="price-item pb-4">
                    <div className="position-relative">
                      <img
                        className="img-fluid rounded-top"
                        src={item.img}
                        alt={item.title}
                      />
                    </div>
                    <div className="text-center bg-light border-bottom border-primary py-5 px-4">
                      <h4>{item.title}</h4>
                      <hr className="text-primary w-50 mx-auto mt-0" />
                      {item.features.map((feature, i) => (
                        <div
                          className="d-flex justify-content-between mb-3"
                          key={i}
                        >
                          <span>{feature}</span>
                          <i className="fa fa-check text-primary pt-1"></i>
                        </div>
                      ))}
                      <a
                        href="/appointment"
                        className="btn btn-primary py-2 px-4"
                      >
                        Agendá tu turno
                      </a>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Pricing;